import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import CommissionList from "./components/list";

const Commissions = () => {
  const Location = useLocation();
  return (
    <>
      <div className="main-page-container">
        <Routes>
          <Route
            path={`/`}
            element={<Navigate replace="/" to={`${Location.pathname}/list`} />}
          ></Route>
          <Route path={"list"} element={<CommissionList />}></Route>
        </Routes>
      </div>
    </>
  );
};

export default Commissions;
